function PlanGroupMerchDivCell(props) {
    return (
        <>{props.value?.product_h1?.map((obj) => obj.label).join(",") ?? "-"}</>
    );
}

export default PlanGroupMerchDivCell;
